'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  return {
    applicant: { dob: !values.applicant.dob && (0, _translate.t)('Applicant 1: Date of Birth is Required') },
    applicants: values.applicants.map(function (applicant, i) {
      var x = i + 2;
      return {
        dob: !applicant.dob && (0, _translate.t)('Applicant %(index)d: Date of Birth is Required', { index: x }),
        additional_data: {
          relationship_to_primary_applicant: !applicant.additional_data.relationship_to_primary_applicant && (0, _translate.t)('Applicant %(index)d: Relationship to primary applicant is Required', { index: x })
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date && (0, _translate.t)('Effective Date is Required'),
      expiry_date: function () {
        if (!values.application.expiry_date) {
          return (0, _translate.t)('Expiry Date is Required');
        }

        var expiryDate = (0, _moment2.default)(values.application.expiry_date);

        if (expiryDate.isSame(values.application.effective_date, 'day') || expiryDate.isBefore(values.application.effective_date, 'day')) {
          return (0, _translate.t)('Expiry date not set properly.');
        }

        return null;
      }(),
      additional_data: {
        eligibility: !values.application.additional_data.eligibility && (0, _translate.t)('Confirmation of eligibility is required'),
        school: !values.application.additional_data.school && (0, _translate.t)('Name of the school you are attending is required'),
        country_of_origin: !values.application.additional_data.country_of_origin && props.countryMessage
      }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/msh/Quote.js
// module id = 415
// module chunks = 0